// Dependencies
import React, { FunctionComponent } from "react";

// Types
import { ActivityChipProps } from "./activity-chip.types";

// Styles
import { Container, Label } from "./activity-chip.styles";

// Utils
import { ternary } from "../../utils/ternary";
import { theme } from "config/theme";

export const ActivityChip: FunctionComponent<ActivityChipProps> = ({
    variant = "default",
    size = "small",
    label,
    firstIconElement,
    lastIconElement,
    handleClick
}) => {
    const labelColor = ternary([
        [variant === "disabled", theme.colors.base[400]],
        [variant === "info", theme.colors.system.info[500]],
        [variant === "success", theme.colors.system.success[500]],
        [variant === "danger", theme.colors.system.danger[500]],
        [variant === "warning", theme.colors.system.warning[500]],
        [variant === "cta", theme.colors.base[100]],
        [variant === "default", theme.colors.base[500]]
    ]);

    return (
        <Container
            className="webapp-chip"
            variant={variant}
            size={size}
            hasCursorPointer={!!handleClick}
            onClick={() => !!handleClick && handleClick()}
        >
            {firstIconElement}

            <Label color={labelColor!} size={size}>
                {label}
            </Label>

            {lastIconElement}
        </Container>
    );
};
